var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43564"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#1745EB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 45.0003V43.2859H37.5V41.667C37.5 40.3409 36.9732 39.0691 36.0355 38.1315C35.0979 37.1938 33.8261 36.667 32.5 36.667H20.8333C19.5073 36.667 18.2355 37.1938 17.2978 38.1315C16.3601 39.0691 15.8333 40.3409 15.8333 41.667V43.2859H12.5V45.0003H45.8333ZM26.6667 21.667C25.5129 21.667 24.3851 22.0091 23.4258 22.6501C22.4666 23.2911 21.7189 24.2021 21.2774 25.268C20.8359 26.3339 20.7203 27.5068 20.9454 28.6384C21.1705 29.7699 21.7261 30.8093 22.5419 31.6251C23.3577 32.4409 24.3971 32.9965 25.5286 33.2216C26.6602 33.4467 27.8331 33.3311 28.899 32.8896C29.9649 32.4481 30.8759 31.7004 31.5169 30.7412C32.1579 29.7819 32.5 28.6541 32.5 27.5003C32.5 25.9532 31.8854 24.4695 30.7915 23.3755C29.6975 22.2816 28.2138 21.667 26.6667 21.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6665 16L40.1667 24.3999L37.3335 21.5999L34.5 24.3999L40.1667 30L51.5 18.8L48.6665 16Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertedIcon);
export default __webpack_public_path__ + "static/media/convertedIcon.397909c50f26590f4eae61961f7bda0b.svg";
export { ForwardRef as ReactComponent };